import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
export default {
  __name: 'index',
  props: {
    effect: {
      type: String,
      default: 'dark',
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['dark', 'light'].indexOf(value) !== -1;
      }
    }
  },
  setup(__props) {
    const store = useStore();
    const language = computed(() => store.getters.language);

    // 切换语言的方法
    const i18n = useI18n();
    const handleSetLanguage = lang => {
      i18n.locale.value = lang;
      store.commit('app/setLanguage', lang);
      ElMessage.success(i18n.t('msg.toast.switchLangSuccess'));
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createBlock(_component_el_dropdown, {
        trigger: "click",
        class: "international",
        onCommand: handleSetLanguage
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            disabled: language.value === 'zh',
            command: "zh"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 中文 ", -1)]))]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_dropdown_item, {
            disabled: language.value === 'en',
            command: "en"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" English ", -1)]))]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
          content: _ctx.$t('msg.navBar.lang'),
          effect: __props.effect
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            id: "guide-lang",
            icon: "language"
          })]),
          _: 1
        }, 8, ["content", "effect"])])]),
        _: 1
      });
    };
  }
};